import { useRef, useState } from "react";
import { FileDown, FileUp } from "lucide-react";
import { http, postDownload, formatApiError } from "../lib/api";
import { toast } from "../lib/notify";

const keepFocus = (e) => e.preventDefault();

// Çoklu seçim listesi için Excel: şablon indir (Kod | Ad | Seç) ya da kendi dosyanı yükle — kod / ad eşleşen kayıtlar seçime eklenir
export default function CheckListExcel({ options, value, onChange, title, testid }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState("");
  const payload = () => options.map((o) => ({ value: String(o.value), label: o.label, keys: (o.keys || []).filter(Boolean).map(String) }));

  const template = async () => {
    setBusy("tpl");
    try { await postDownload("/tools/checklist-template", { title, options: payload() }, `${title}-secim-sablonu.xlsx`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  const upload = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy("up");
    try {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("options", JSON.stringify(payload()));
      const { data } = await http.post("/tools/checklist-match", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const added = data.matched.filter((v) => !value.includes(v));
      onChange([...new Set([...value, ...data.matched])]);
      if (data.matched.length) toast.success(`${data.matched.length} kayıt eşleşti, ${added.length} yeni seçildi${data.unmatched_total ? ` · ${data.unmatched_total} eşleşmeyen değer` : ""}`);
      else toast.error(`Eşleşen kayıt yok${data.unmatched.length ? ` — örn. ${data.unmatched.slice(0, 3).join(", ")}` : ""}`);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(""); }
  };

  return (
    <>
      <button type="button" tabIndex={-1} onMouseDown={keepFocus} onClick={template} disabled={!options.length || !!busy} title="Excel şablonu indir: tüm kayıtlar (Kod | Ad | Seç). 'Seç' sütununa X yazıp yükleyin" data-testid={`${testid}-excel-template`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-emerald-300 text-[11px] font-semibold text-emerald-800 hover:bg-emerald-50 disabled:opacity-40"><FileDown className="w-3 h-3" /> Şablon</button>
      <button type="button" tabIndex={-1} onMouseDown={keepFocus} onClick={() => fileRef.current?.click()} disabled={!options.length || !!busy} title="Excel'den toplu seç: şablon ya da kendi dosyanız — kod / ad eşleşen kayıtlar seçilir" data-testid={`${testid}-excel-upload`}
        className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-emerald-300 text-[11px] font-semibold text-emerald-800 hover:bg-emerald-50 disabled:opacity-40"><FileUp className="w-3 h-3" /> {busy === "up" ? "Yükleniyor…" : "Excel'den Seç"}</button>
      <input ref={fileRef} type="file" accept=".xlsx" className="hidden" onChange={upload} data-testid={`${testid}-excel-file`} />
    </>
  );
}
